import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap'
import i18next from 'i18next'

import Avatar from '../../components/common/Avatar'
import { useAppSelector } from '../../hooks/redux'

const logOutIcon = '/images/icons/logout.svg'

/**
 * Shape of the authed user object stored in the auth slice.
 * Defined locally because auth.user is typed as `unknown` in the reducer.
 */
interface AuthedUser {
    name?: string
    surname?: string
}

/**
 * Right-side nav cluster for the top navbar.
 *
 * Renders a user avatar with a display name, a logout link and a
 * language-switcher dropdown.
 */
const TopNavRightSideNavItem = () => {
    const user = useAppSelector(state => state.auth.user) as AuthedUser | null
    const [langDropdownOpen, setLangDropdownOpen] = useState(false)

    const getUserName = (): string => {
        if (!user?.name || !user?.surname) {
            return ''
        }

        return `${user.name.charAt(0)}. ${user.surname}`
    }

    return (
        <Nav
            navbar
            className='navbar-nav-icons ml-auto flex-row align-items-center'
        >
            <NavItem>
                <Link className="ml-2 d-flex align-items-center" to="/user/profile">
                    <Avatar size="l" name={user?.surname} className="mr-2" />
                    {getUserName()}
                </Link>
            </NavItem>
            <NavItem>
                <NavLink tag={Link} to='/logout' id='logout' className="ml-3" title="Logout">
                    <img src={logOutIcon} alt="Logout" />
                </NavLink>
            </NavItem>
            <NavItem>
                <Dropdown isOpen={langDropdownOpen} toggle={() => setLangDropdownOpen(open => !open)}>
                    <DropdownToggle color="link" size="sm" className="text-600 btn-reveal mr-3">
                        <img src={`/images/flags/${i18next.language}.svg`} width="10" alt="" />
                    </DropdownToggle>
                    <DropdownMenu right className="border py-2">
                        <DropdownItem className="d-flex align-items-center justify-content-center" href="/cs">
                            <img src="/images/flags/cs.svg" width="30" alt="" />
                        </DropdownItem>
                        <DropdownItem className="d-flex align-items-center justify-content-center" href="/en">
                            <img src="/images/flags/en.svg" width="30" alt="" />
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </NavItem>
        </Nav>
    )
}

export default TopNavRightSideNavItem
